/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { NumericDiff } from "components/search/input/DifferencePanel/common";
import { NameBasedSteelGradePlanItem } from "store/api/generatedApi";

import { CategoryConfigFactory } from "components/search/input/DifferencePanel/common";

export const ProductionItemConfigFactory: CategoryConfigFactory<
  NameBasedSteelGradePlanItem
> = ({ t, formatNumber2DP }) => ({
  num_heats: {
    title: t("heats"),
    format: (val) => val,
    renderDiff: ({ updatedVal, previousVal }) => (
      <NumericDiff
        previous={previousVal ?? 0}
        updated={updatedVal ?? 0}
        format={formatNumber2DP}
      />
    ),
  },
});
